import { render, staticRenderFns } from "./UpdatePortalUserModal.vue?vue&type=template&id=47de9e80&"
import script from "./UpdatePortalUserModal.vue?vue&type=script&lang=js&"
export * from "./UpdatePortalUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports